import request from '@/utils/request'


// 查询动态信息列表
export function listArticle(query) {
    return request({
        url: '/h5/article/list',
        method: 'get',
        params: query
    })
}

// 查询动态信息详情
export function listArticleById(id) {
    return request({
        url: '/h5/article/'+id,
        method: 'get',
    })
}

// 增加点击数
export function upArticleById(id) {
    return request({
        url: '/h5/article/clink/'+id,
        method: 'get',
    })
}
